/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SsoimageQueryResponse,
  GetApiV1SsoimageQueryParams,
  GetApiV1Ssoimage400,
  GetApiV1Ssoimage401,
  GetApiV1Ssoimage500,
} from "../../types/SSOImageController/GetApiV1Ssoimage.ts";

function getGetApiV1SsoimageUrl() {
  const res = { method: "GET", url: `/api/v1/ssoimage` as const };
  return res;
}

/**
 * @description Retorna todas as imagens e os idiomas ativos. **(Requer Authorization para autenticação)**
 * @summary Grid principal das imagens (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage}
 */
export async function getApiV1Ssoimage(
  params?: GetApiV1SsoimageQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SsoimageQueryResponse,
    ResponseErrorConfig<
      GetApiV1Ssoimage400 | GetApiV1Ssoimage401 | GetApiV1Ssoimage500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SsoimageUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
